import { render, staticRenderFns } from "./SuperAdminRegionsPage.vue?vue&type=template&id=de4faefe"
import script from "./SuperAdminRegionsPage.vue?vue&type=script&lang=js"
export * from "./SuperAdminRegionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports